import { forwardRef } from "react"

import {
  Link as RouterLink,
  LinkProps as RouterLinkProps,
} from "react-router-dom"
import MuiLink, { LinkProps as MuiLinkProps } from "@material-ui/core/Link"
import Tab, { TabProps } from "@material-ui/core/Tab"
import { Authority, useAuthenticated } from "providers/A12n"
import Button, { ButtonProps } from "@material-ui/core/Button"
import { css } from "@emotion/css"

const AdapterLink = forwardRef<HTMLAnchorElement, RouterLinkProps>(
  (props, ref) => <RouterLink innerRef={ref} {...props} />,
)

export function Link(props: RouterLinkProps & MuiLinkProps) {
  return <MuiLink component={AdapterLink} {...props} />
}

export function ButtonLink(props: RouterLinkProps & ButtonProps) {
  return <Button component={AdapterLink} {...props} className={width} />
}

export function TabLink(
  props: RouterLinkProps & TabProps & { allowed?: Authority[] },
) {
  const { hasAuthority } = useAuthenticated()

  return props?.allowed ? (
    hasAuthority(props.allowed) ? (
      <Tab component={AdapterLink} {...props} />
    ) : (
      <span />
    )
  ) : (
    <Tab component={AdapterLink} {...props} />
  )
}

const width = css`
  width: var(--spacing-m);
`
